export const getPartNumberFromUrl = (url) => url.split('pn/')[1];

export default getPartNumberFromUrl;
